import { render, staticRenderFns } from "./PostEditServiice.vue?vue&type=template&id=3775dcf2"
import script from "./PostEditServiice.vue?vue&type=script&lang=js"
export * from "./PostEditServiice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports